import React from 'react';

const External: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M14 1.484v10.88c0 .82-.672 1.484-1.5 1.484h-11c-.828 0-1.5-.664-1.5-1.484V1.484C0 .664.672 0 1.5 0h11c.828 0 1.5.664 1.5 1.484zm-2.75.494h-3.5c-.665 0-1.002.8-.53 1.267l1 .988-6.11 6.044a.368.368 0 000 .525l.97.959a.378.378 0 00.53 0l6.11-6.044 1 .989c.47.464 1.28.138 1.28-.525v-3.46a.746.746 0 00-.75-.743z"
    ></path>
  </svg>
);
export default External;
